import { z } from 'zod';

import { baseResponseSchema } from '@/schemas/base.schema';

export const UserProfileRequestSchema = z.void();

export const UserProfileResponseSchema = baseResponseSchema.extend({
  data: z.object({
    id: z.string().uuid(),
    companyId: z.string().uuid(),
    firstName: z.string(),
    lastName: z.string(),
    avatar: z.string().url().nullable(),
    email: z.string().email(),
  }),
});

export type TUserProfileRequestSchema = z.infer<typeof UserProfileRequestSchema>;
export type TUserProfileResponseSchema = z.infer<typeof UserProfileResponseSchema>;
